class MFRFloatingTestimonials {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      testimony: ".floating-testimonials__image",
      wrapper: ".floating-testimonials",
      sectionContent: ".section-title, .section-text, .button-set",
    };

    this.init();
  }

  init() {
    this.$testimony = this.$element.find(this.selectors.testimony);
    this.$wrapper = this.$element.find(this.selectors.wrapper);
    this.$sectionContent = this.$element.find(this.selectors.sectionContent);

    const windowWidth = $(window).width();
    $(window).on("resize", () => {
      if ($(window).width() != windowWidth) {
        this.initializeFloatingElements;
      }
    });

    this.initializeFloatingElements();
  }

  initializeFloatingElements() {

    this.$testimony.each((i, e) =>
      gsap.set($(e), {
        rotate: `${Math.floor(Math.random() * (7 - -7 + 1) + -7)}deg`,
      })
    );

    if( $( window ).width() <= 639 ) return;

    this.initDrag();
  }

  initDrag() {
    this.initGrabCursor();
    // target elements with the "draggable" class
    interact(`#${this.$element.attr("id")} ${this.selectors.testimony}`).draggable({
      // enable inertial throwing
      inertia: true,
      // keep the element within the area of it's parent
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
          endOnly: true,
        }),
      ],
      // enable autoScroll
      autoScroll: false,

      listeners: {
        // call this function on every dragmove event
        move: this.dragMoveListener,

        // call this function on every dragend event
        end(event) {},
      },
    });

    // this function is used later in the resizing and gesture demos
    window.dragMoveListener = this.dragMoveListener;
  }

  dragMoveListener(event) {
    var target = event.target;
    // keep the dragged position in the data-x/data-y attributes
    var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
    var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

    // translate the element
    gsap.set($(target), {
      x: x,
      y: y,
    });

    // update the posiion attributes
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);
  }

  initGrabCursor() {
    this.$testimony.on("mousedown", (e) =>
      $(e.currentTarget).addClass("grabbing")
    );
    this.$testimony.on("mouseup", (e) =>
      $(e.currentTarget).removeClass("grabbing")
    );
  }
}